export interface SelectOption {
	value: string|number|boolean;
	label: string|number|boolean;
}

export const DefaultOptions: SelectOption[] = [{value: '', label: 'Please Select'}];
